import React, { Component } from "react";

import { monthName } from "../../../../utils/CommonFunction";

export default class ConfirmAndSaveConfirmDialog extends Component {
  nextFiscalYear(yearEnd, monthEnd) {
    const nextFiscalYearStartYear = monthEnd === 12 ? yearEnd + 1 : yearEnd;
    const nextFiscalYearStartMonth = monthEnd === 12 ? 1 : monthEnd + 1;
    const nextFiscalYearEndYear = nextFiscalYearStartYear + 1;
    const nextFiscalYearEndMonth = 3;

    return {
      startYear: nextFiscalYearStartYear,
      startMonth: monthName(nextFiscalYearStartMonth),
      endYear: nextFiscalYearEndYear,
      endMonth: monthName(nextFiscalYearEndMonth),
    };
  }

  render() {
    const { yearStart, monthStart, yearEnd, monthEnd } =
      this.props.currentLeaveCarryYears;

    const { startYear, startMonth, endYear, endMonth } = this.nextFiscalYear(
      yearEnd,
      monthEnd
    );

    return (
      <div className="col-sm-12 mt20">
        <div
          className="bg-primary"
          style={{ padding: "10px", marginBottom: "40px", marginTop: "10px" }}
        >
          <p style={{ fontSize: "20px", fontWeight: "bold" }}>
            Finish the Leave Carrying Process
          </p>
        </div>
        <div style={{ paddingLeft: "20px", paddingRight: "20px" }}>
          <h2>You are about to finish the leave carry process!</h2>
          <h3>
            Once completed, employees will be able to submit leave applications
            as usual.
          </h3>
        </div>
        <div
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            marginTop: "50px",
          }}
        >
          <div style={{ height: "120px" }}>
            <div>
              You have successfully calculated the unused leave days for the
              fiscal year {monthName(monthStart)} {yearStart} to{" "}
              {monthName(monthEnd)} {yearEnd}. These results will now be carried
              forward to the next fiscal year, {startMonth} {startYear} to{" "}
              {endMonth} {endYear}, for employees to utilize.
            </div>
          </div>
        </div>

        <div
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            marginTop: "50px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <button
            type="button"
            className={"btn btn-primary"}
            style={{
              width: "150px",
              backgroundColor: "grey",
              color: "white",
            }}
            onClick={this.props.hideDialog}
          >
            Cancel
          </button>
          <div
            style={{
              width: "50px",
            }}
          ></div>
          <button
            type="button"
            className={"btn btn-primary"}
            style={{
              width: "150px",
            }}
            onClick={this.props.onClickConfirm}
          >
            Confirm
          </button>
        </div>
      </div>
    );
  }
}
